"use strict";
import { Percent } from "@uniswap/sdk-core";
import JSBI from "jsbi";
export const ADDRESS_ZERO = "0x0000000000000000000000000000000000000000";
export const MSG_SENDER = "0x0000000000000000000000000000000000000001";
export const ADDRESS_THIS = "0x0000000000000000000000000000000000000002";
export const ZERO = JSBI.BigInt(0);
export const ONE = JSBI.BigInt(1);
export const MIXED_QUOTER_V1_V2_FEE_PATH_PLACEHOLDER = 1 << 23;
export const MIXED_QUOTER_V2_V2_FEE_PATH_PLACEHOLDER = 2 << 4;
export const MIXED_QUOTER_V2_V3_FEE_PATH_PLACEHOLDER = 3 << 20;
export const MIXED_QUOTER_V2_V4_FEE_PATH_PLACEHOLDER = 4 << 20;
export const ZERO_PERCENT = new Percent(ZERO);
export const ONE_HUNDRED_PERCENT = new Percent(100, 100);
